import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';


class StaticSmallCard extends React.Component {
  static propTypes = {
    description: PropTypes.string,
    name: PropTypes.string,
    photo: PropTypes.string,
    price: PropTypes.number
  };

  render() {
    let desc = this.props.description;
    //if there is an item description, truncate it to 7 words
    if (desc) {
      desc = desc.split(" ").splice(0, 7).join(" ");
    }

    return (
      <div className="small-card">
        <div className="small-thumb"><img src={this.props.photo}/></div>
        <div className="item-content">
          <h4 className="small-item-title">{this.props.name}</h4>
          {
          this.props.price ? 
          <span className="price">{this.props.price}€</span>:
          <FormattedMessage id="price_under_request">
            {(message) => <span className="price">
            {message}
          </span>}
          </FormattedMessage>
          
          }
          <p className="description">{desc}</p>
        </div>
      </div>
    );
  }
}

export default StaticSmallCard;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/StaticSmallCard.js
 **/